<template>
  <iframe :src="reportPath" width="100%" height="1000px;"></iframe>
</template>

<script>
import { getIframeToken } from "@/model/api";

export default {
  name: "RunReport",
  props: {
    runReport: Object,
  },
  data() {
    return {
      reportPath: "",
    };
  },
  async created() {
    const { token } = await getIframeToken(
      "/simulationRun/run-report",
      this.runReport.workerId,
      this.runReport.id
    );
    this.reportPath =
      "/compliance-server/api/simulationRun/run-report/" +
      this.runReport.workerId +
      "/" +
      this.runReport.id +
      "/index.html?iframeToken=" +
      token;
  },
};
</script>
